import Kanban, {
  KanbanColumn,
  KanbanDataSource,
} from "smart-webcomponents-react/kanban";
import { useEffect, useRef, useState } from "react";
import TaskSubTaskForm from "@/components/tasks/taskSubTaskForm";
import useCreateTaskMutation, {
  Task,
} from "@/api/mutation/useTaskCreateMutation";
import { useParams } from "react-router-dom";
import "./index.css";
import { createRoot } from "react-dom/client";
import TaskShellView from "./taskShellView";
import { toast } from "react-toastify";
import RulesSetups from "./rulesSetups/rulesSetups";
import { KanbanColumnType } from "@/api/mutation/useKanbanCreateColumn";
import { Button } from "@/components/ui/button";
import useUpdateTaskMutation from "@/api/mutation/useTaskUpdateMutation";
import Dialog from "@/components/common/Dialog";
import RulesForm from "./rulesSetups/rulesForm";
import CrossIcon from "@/assets/svg/CrossIcon.svg";
import TrashCan from "@/assets/svg/TrashCan.svg";
import useAllKanbanColumnQuery from "@/api/query/useAllKanbanColumn";
// import Loader from "@/components/common/Loader";
import { updateTaskSchema } from "@backend/src/schemas/taskSchema";
import { z } from "zod";
import { UserRoleEnumValue } from "@backend/src/schemas/enums";
import { useUser } from "@/hooks/useUser";
import FooterInput, { footerData } from "./footerView";
import useRemoveTaskMutation from "@/api/mutation/useTaskRemove";
import Plus from "@/assets/svg/NewPlus.svg";
// import ReactDOMServer from "react-dom/server";
import { errorConfig } from "@/lib/toastError";
// import ReactDOM, { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import useProjectDetail from "@/api/query/useProjectDetailQuery";
import YallowInfoIcon from "@/assets/svg/YallowInfoIcon.svg";

export interface columnsRenderData {
  label: string;
  dataField: string;
  orientation: string;
  collapsible: boolean;
  collapsed: boolean;
  addNewButton: boolean;
  allowRemove: boolean;
  allowHide: boolean;
  editable: boolean;
  reorder: boolean;
}
export type ExtendedKanbanDataSource = KanbanDataSource & {
  users: string;
  projectRole: keyof typeof UserRoleEnumValue | undefined;
  organisationRole: keyof typeof UserRoleEnumValue | undefined;
  createdByUserId: string;
  loginUserId: string | undefined;
  subTask: number;
  mileStone: boolean;
  parentTask: string;
  taskStatus: string;
};
function KanbanView(props: {
  data: Task[];
  openSetting: boolean;
  refetch: () => void;
  rowTasksData: Task[] | undefined;
  userRole?: keyof typeof UserRoleEnumValue;
}) {
  const [dialogRendered, setDialogRendered] = useState<string | undefined>(
    undefined
  );
  const [isTaskShow, setIsTaskShow] = useState<boolean>(false);
  const childRef = useRef<Kanban>(null);
  const { projectId } = useParams();
  const allKanbanColumn = useAllKanbanColumnQuery(projectId);
  const [dataSource, setDataSource] = useState<ExtendedKanbanDataSource[]>([]);
  const [isColumnsOpen, setIsColumnsOpen] = useState<boolean>(false);
  const [Columns, setColumns] = useState<KanbanColumn[]>();
  const [closePopup, setClosePopup] = useState<boolean>(props.openSetting);
  const [rawData, setRawData] = useState<KanbanColumnType[]>();
  const user = useUser();
  const { t } = useTranslation();

  useEffect(() => {
    if (allKanbanColumn.status == "success") {
      setOpen();
    }
  }, [allKanbanColumn.status == "success"]);

  useEffect(() => {
    setClosePopup(props.openSetting);
  }, [props.openSetting]);

  const close = () => {
    setDialogRendered(undefined);
    setIsTaskShow(false);
    props.refetch();
  };

  useEffect(() => {
    if (allKanbanColumn.data?.data.data) {
      allKanbanColumn.data?.data.data.sort(
        (a, b) => (a.percentage ?? 0) - (b.percentage ?? 0)
      );
      handleColumn(allKanbanColumn.data?.data.data);
    }
  }, [allKanbanColumn.data?.data.data]);

  useEffect(() => {
    setData();
  }, [props.data, Columns]);
  const setData = () => {
    if (props.data) {
      setDataSource(
        props.data
          ?.map((task) => {
            return DataConvertToKanbanDataSource(task);
          })
          ?.sort((a, b) => {
            if (a.startDate && b.startDate) {
              return (
                new Date(a.startDate).getTime() -
                new Date(b.startDate).getTime()
              );
            }
            return -1;
          })
      );
    }
  };
  const [scheduledError, setScheduledError] = useState(false);
  const taskStatusUpdateMutation = useUpdateTaskMutation();
  const statusUpdate = (e: (Event & CustomEvent) | undefined) => {
    const column = allKanbanColumn.data?.data.data.find(
      (d) => d.kanbanColumnId === e?.detail.value.status
    );
    const task = props.data.find((t) => t.taskId == e?.detail.id);

    if (task?.milestoneIndicator) {
      if (
        !(
          column?.percentage == null ||
          column?.percentage == 0 ||
          column?.percentage == 100
        )
      ) {
        setDataSource(
          props.data?.map((task) => DataConvertToKanbanDataSource(task))
        );
        toast.error(
          t("A milestone can only have 0% or 100% progress."),
          errorConfig
        );
        return;
      }
    }
    let val: z.infer<typeof updateTaskSchema> & { id?: string } = {
      id: e?.detail.value.id,
    };

    if (column?.percentage === null) {
      val = {
        ...val,
        kanbanColumnId: e?.detail.value.status,
      };
    } else {
      val = {
        ...val,
        completionPecentage: Number(column?.percentage),
        kanbanColumnId: task?.milestoneIndicator ? e?.detail.value.status : "",
      };
    }

    taskStatusUpdateMutation.mutate(val, {
      onSuccess() {
        props.refetch();
      },
      onError(error) {
        // props.refetch();
        setData();
        toast.error(
          errorKeyFormate(error.response?.data.message + ""),
          errorConfig
        );
      },
    });
  };

  function DataConvertToKanbanDataSource(data: Task): ExtendedKanbanDataSource {
    return {
      organisationRole: user?.user?.userOrganisation[0]?.role || "TEAM_MEMBER",
      createdByUserId: data.createdByUserId,
      loginUserId: user?.user?.userId,
      projectRole: props.userRole,
      id: data.taskId,
      color: data.flag,
      text: data.taskName,
      status: setStatus(data),
      progress: data.completionPecentage ? Number(data.completionPecentage) : 0,
      startDate: data.startDate,
      dueDate: data.dueDate ?? data.endDate,
      users: JSON.stringify(data.assignedUsers),
      taskStatus: data.status,
      parentTask:
        props.rowTasksData?.find((t) => t.taskId == data.parentTaskId)
          ?.taskName ?? "",
      subTask:
        props.rowTasksData?.filter((i) => data.taskId == i.parentTaskId)
          .length ?? 0,
      comments: data.comments?.map((comment) => {
        return {
          text: comment.commentText,
          time: comment.createdAt,
          userId: comment.commentByUserId,
        };
      }),
      mileStone: data.milestoneIndicator,
    };
  }
  const taskCustomFields = [
    {
      label: "Users",
      dataField: "users",
    },
    {
      label: "Sub task count",
      dataField: "subTask",
    },
  ];
  const setStatus = (task: Task) => {
    let closestNumber = 0;
    if (
      Columns &&
      Columns.length == 1 &&
      allKanbanColumn.data?.data.data.filter((d) => !d.percentage)[0]
        .kanbanColumnId
    ) {
      return allKanbanColumn.data?.data.data.filter(
        (d) => d.percentage == undefined || d.percentage == null
      )[0].kanbanColumnId;
    }
    if (Columns && Columns.length > 0) {
      if (task.kanbanColumnId) {
        if (
          allKanbanColumn.data?.data.data.some(
            (d) => d.kanbanColumnId == task.kanbanColumnId
          )
        ) {
          return task.kanbanColumnId;
        } else {
          return allKanbanColumn.data?.data.data.filter(
            (d) => d.percentage == undefined || d.percentage == null
          )[0].kanbanColumnId;
        }
      } else {
        for (const num of Columns) {
          const percentage = allKanbanColumn.data?.data.data.find(
            (d) => d.kanbanColumnId == num.dataField
          )?.percentage;
          if (percentage !== null && percentage !== undefined) {
            if (
              closestNumber === 0 ||
              Number(task.completionPecentage) >= percentage
            ) {
              closestNumber = percentage;
            }
          }
        }
      }
    }
    if (Number(task.completionPecentage) < closestNumber) {
      const percentage = allKanbanColumn.data?.data.data.find(
        (d) => !d.percentage && d.name == "Backlog"
      )?.kanbanColumnId;
      return percentage;
    } else if (closestNumber == 0 && !rawData?.find((d) => d.percentage)) {
      return allKanbanColumn.data?.data.data
        .filter((d) => d.percentage == undefined || d.percentage == null)
        .find((t) => t.name == "Backlog")?.kanbanColumnId;
    } else {
      return rawData?.find((e) => e.percentage == closestNumber)
        ?.kanbanColumnId;
    }
  };

  const onOpening = (e: (Event & CustomEvent) | undefined) => {
    e?.preventDefault();
    if (e?.detail.purpose === "add") {
      setDialogRendered(undefined), setIsTaskShow(true);
    } else {
      setDialogRendered(e?.detail.value.id);
    }
  };
  const onTaskRender = (
    taskElement: HTMLElement,
    data: ExtendedKanbanDataSource
  ) => {
    const root = createRoot(taskElement);
    root.render(
      <TaskShellView
        taskData={data}
        open={setDialogRendered}
        remove={(e) => setTaskRemove(e ?? "")}
      />
    );
    return taskElement;
  };

  const handleColumn = (data: KanbanColumnType[]) => {
    if (data.length <= 0) {
      setClosePopup(true);
    }
    setRawData(data);
    const column: KanbanColumn[] = data.map((d) => {
      return {
        label: d.name.charAt(0).toUpperCase() + d.name.slice(1),
        dataField: d.kanbanColumnId,
        width: 300,
      };
    });
    const backlogIndex = column.findIndex(
      (column) => column.label === "Backlog"
    );

    if (backlogIndex !== -1 && backlogIndex !== 0) {
      const backlogColumn = column.splice(backlogIndex, 1)[0];

      column.unshift(backlogColumn);
    }
    if (
      props.userRole &&
      !(
        props.userRole == UserRoleEnumValue.TEAM_MEMBER ||
        props.userRole == UserRoleEnumValue.COLLABORATOR
      )
    ) {
      const createcolum: KanbanColumn = {
        label: t("add_new_column"),
        dataField: "Add New column",
        width: 300,
      };
      setColumns([...column, createcolum]);
    } else {
      setColumns(column);
    }
  };

  const onDragging = (e: (Event & CustomEvent) | undefined) => {
    const task = props.data.find((t) => t.taskId == e?.detail.data.ItemData.id);
    const columePer = e?.detail.item.column.label;
    const today = new Date();
    const todayDateOnly = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );

    const startDate = new Date(task?.startDate ?? "");
    const startDateOnly = new Date(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate()
    );
    const project = projectDetails.data?.data.data;
    if (
      project?.assignedUsers.find(
        (u) =>
          u.projectRole == UserRoleEnumValue.COLLABORATOR &&
          u.user.userId == user.user?.userId
      )
    ) {
      toast.error(
        t("gantt_chart_you_are_not_authorize_collaborator"),
        errorConfig
      );
    } else if (!allowed(task)) {
      toast.error(t("gantt_chart_you_are_not_authorize"), errorConfig);
    } else if (e?.detail.data.ItemData.subTask > 0) {
      toast.error(
        t(
          "You cannot move a parent task between columns. It is automatically moved based on the progress of its subtasks"
        ),
        errorConfig
      );
      e?.preventDefault();
    }
     else if (
      columePer &&
      startDateOnly > todayDateOnly  &&
      task?.completionPecentage !== columePer
    ) {
      setScheduledError(true);
      e?.preventDefault();
    }
  };
  const setOpen = () => {
    if (
      allKanbanColumn.data?.data.data &&
      allKanbanColumn.data.data.data.length > 0
    ) {
      setClosePopup(false);
    } else {
      setClosePopup(true);
    }
  };
  const projectDetails = useProjectDetail(projectId, true);

  const allowed = (task: Task | undefined) => {
    const project = projectDetails.data?.data.data;
    if (
      task &&
      project?.assignedUsers.find(
        (u) =>
          u.projectRole == UserRoleEnumValue.TEAM_MEMBER &&
          u.user.userId == user.user?.userId
      ) &&
      task.createdByUserId == user.user?.userId
    ) {
      return true;
    } else if (
      project?.assignedUsers.find(
        (u) =>
          (u.projectRole == UserRoleEnumValue.PROJECT_MANAGER ||
            u.projectRole == UserRoleEnumValue.ADMINISTRATOR) &&
          u.user.userId == user.user?.userId
      )
    ) {
      return true;
    } else if (
      user.user?.userOrganisation[0]?.role == UserRoleEnumValue.ADMINISTRATOR
    ) {
      return true;
    } else {
      return false;
    }
  };

  const onColumnFooterRender = (element: Element, columnData: KanbanColumn) => {
    if (props.userRole !== UserRoleEnumValue.COLLABORATOR) {
      const root = createRoot(element);
      root.render(
        <FooterInput
          column={rawData}
          projectId={projectId}
          data={columnData}
          callBack={(data: footerData) => submit(data)}
        />
      );
    }
  };
  const taskCreateMutation = useCreateTaskMutation(projectId, "");

  const submit = (taskData: footerData) => {
    const startDate = new Date();
    startDate.setUTCHours(0, 0, 0, 0);
    startDate.setDate(startDate.getDate());
    taskCreateMutation.mutate(
      {
        taskName: taskData?.taskName ?? "",
        duration: 1,
        startDate: startDate,
        completionPecentage: taskData?.percentage,
        kanbanColumnId: taskData?.kanbanColumnId,
      },
      {
        onSuccess() {
          // toast.success(data.data.message);
          allKanbanColumn.refetch();
          props.refetch();
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message + ""),
            errorConfig
          );
        },
      }
    );
  };

  const onColumnHeaderRender = (element: Element, columnData: KanbanColumn) => {
    const newEl = element;
    if (columnData.dataField == "Add New column") {
      element.parentElement?.classList.add("!bg-transparent");
      element.parentElement?.classList.add("!shadow-none");
      element.parentElement?.children[1].classList.add("!hidden");
      element.parentElement?.children[2].classList.add("!hidden");
      const root = createRoot(element);
      root.render(
        <div className="bg-gray-200 p-2 rounded-xl">
          <Button
            variant={"primary"}
            className="w-full"
            value={"Create Columns"}
            onClick={() => setIsColumnsOpen(true)}
          >
            <img src={Plus} className="h-4 w-4 mr-1" />
            {t("add_new_column")}
          </Button>
        </div>
      );
    } /*  else {
      const text = element.children[1].children[1].textContent;
      const regex = /\((.*?)\)/;
      const match = regex.exec(text ?? "");
      const result = match ? match[1] : 0;
      const footer = element.parentElement?.getElementsByClassName(
        "smart-kanban-column-footer"
      )[0];
      if (result == 0 && footer) {
        const root = createRoot(footer);
        root.render(
          <FooterInput
            column={rawData}
            projectId={projectId}
            data={columnData}
            callBack={(data: footerData) => submit(data)}
          />
        );
      }
    } */
    return newEl;
  };
  const removeTaskMutation = useRemoveTaskMutation();
  const [taskRemove, setTaskRemove] = useState("");

  const removeTask = (id: string) => {
    removeTaskMutation.mutate(id, {
      onSuccess(data) {
        toast.success(data.data.message);
        setTaskRemove("");
        props.refetch();
      },
      onError(error) {
        toast.success(error.message);
        setTaskRemove("");
      },
    });
  };
  useEffect(() => {
    if (dataSource.length > 0) {
      for (const column of document.querySelectorAll(".smart-kanban-column")) {
        if (column.getAttribute("data-attribute") !== "Add New column") {
          if (
            column.getElementsByClassName("summary")[0] &&
            column.getElementsByClassName("summary")[0]?.textContent == ""
          ) {
            column.getElementsByClassName("summary")[0].textContent = "0";
          }
        }
      }
    }
  }, [dataSource, Columns]);
  return (
    <div className="w-full h-full scroll relative p-2">
      <div
        className={`flex flex-col h-full w-full ${
          !closePopup ? "block" : "block"
        }`}
      >
        {
          <Kanban
            onTaskClick={(e) => e?.preventDefault()}
            ref={childRef}
            {...props}
            columns={Columns}
            headerPosition="none"
            dataSource={dataSource}
            className="!h-[95%] !w-full kanban select-none"
            taskCustomFields={taskCustomFields}
            onTaskRender={onTaskRender}
            columnSummary={true}
            columnFooter={true}
            onColumnFooterRender={onColumnFooterRender}
            onColumnHeaderRender={onColumnHeaderRender}
            onReady={() => {
              childRef.current?.addSort("startDate", "ascending");
            }}
            onDragEnd={(e) => {
              onDragging(e as (Event & CustomEvent) | undefined);
            }}
            onTaskDoubleClick={(e) =>
              onOpening(e as (Event & CustomEvent) | undefined)
            }
            onOpening={(e) => onOpening(e as (Event & CustomEvent) | undefined)}
            onTaskUpdate={(e) =>
              statusUpdate(e as (Event & CustomEvent) | undefined)
            }
          />
        }
      </div>

      {(dialogRendered || isTaskShow) && Boolean(projectId) && (
        <TaskSubTaskForm
          close={close}
          taskId={dialogRendered ?? undefined}
          projectId={projectId}
        />
      )}
      <div
        className={`${
          closePopup && projectId ? "block" : "hidden"
        } h-full w-full absolute !z-10 top-0 bg-white`}
      >
        <RulesSetups
          key={"RulesSetups#1"}
          setColumes={(data) => handleColumn(data)}
          close={() => {
            setClosePopup(false);
            setOpen();
          }}
        />
      </div>
      <Dialog
        isOpen={isColumnsOpen}
        modalClass="rounded-md p-3 w-80"
        onClose={() => {}}
      >
        <div className="flex justify-between mb-3 ">
          <div className="text-lg text-[#0D062D]">{t("create_column")}</div>
          <Button variant={"none"} onClick={() => setIsColumnsOpen(false)}>
            <img src={CrossIcon} />
          </Button>
        </div>
        <RulesForm
          projectId={projectId ?? ""}
          refetch={() => allKanbanColumn.refetch()}
          close={() => setIsColumnsOpen(false)}
          rules={rawData}
        />
      </Dialog>
      <Dialog
        isOpen={Boolean(taskRemove)}
        onClose={() => {}}
        modalClass="rounded-lg"
      >
        <div className="flex flex-col gap-2 p-6 ">
          <img src={TrashCan} className="w-12 m-auto" />{" "}
          {t("common_delete_message")}
          <div className="flex gap-2 ml-auto">
            <Button variant={"outline"} onClick={() => setTaskRemove("")}>
              {t("cancel")}
            </Button>
            <Button
              variant={"primary"}
              isLoading={removeTaskMutation.isPending}
              disabled={removeTaskMutation.isPending}
              onClick={() => removeTask(taskRemove)}
            >
              {t("delete")}
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog
        isOpen={scheduledError}
        onClose={() => {}}
        modalClass="rounded-lg w-1/3"
      >
        <div className="flex flex-col gap-2 p-6 ">
          <img src={YallowInfoIcon} className="w-12 m-auto" />{" "}
          <div dangerouslySetInnerHTML={{ __html: t("futureTaskWarning") }} />
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"primary"}
              onClick={() => {
                setScheduledError(false);
              }}
            >
              {t("ok")}
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default KanbanView;
